export enum MimeTypes {
  PDF = "application/pdf",
  XLS = "application/vnd.ms-excel",
  ZIP = "application/zip",
  PFX = "application/x-pkcs12",
  PNG = "image/png",
  JPG = "image/jpg",
  DOC = "application/msword",
  XML = "application/xml"
}

export interface IDownload {
  execute(file: Blob, fileName: string): void;
}

export interface IDownloadOnBrowser {
  download(file: Blob, fileName: string): void;
}
